import {
  REMOVE_ACTIVE_IMMOBILIZE_VEHICLE,
  SET_ACTIVE_IMMOBILIZE_VEHICLE,
  SET_LOADING,
  UPDATE_ACTIVE_IMMOBILIZE_VEHICLE,
  SET_VSS_TOKEN,
} from "../actions/immobilizer.action";

const vssDevices = {
  52448: "STL030924",
  53872: "STL230924",
  54186: "STL330924",
  // locator accounts
  34263: "STL130924",
  36264: "STL130924",
  37489: "STL130924",
  // sgdw : Lexus 52085
  56179: "STL130924",
  // Danniyeh (2)
  57745: "STL630924",
  57746: "STL730924",
  64356: "STL010022",

  // dubaiship
  56432: "STL530924",

  // lausanne  : Fortuner 16570
  60121 : 'STL830924',

  // Dash Cam ME 40 : test (midhun, sanjith, shameem)
  6136: "STL93024",
  6708: "STL93024",
  31435: "STL93024",

  // vartisa
  // Duster 24607
  60460: "STL010011",
  // Audi Q7 25216
  60463: "STL010014",
  // Mercedes S560 60251
  60451:"STL010013",
  // Rush 74119
  60468 : "STL100001",
  // Teramount 83462
  60455 :"STL010012",
  // Duster 84497
  60467 :"STL010010",

  // fahbs
  // Dani W31803
  38070: "STL010016",
  68461: "STL010040",
  25383: "STL010041",
  71446: "STL010046",

  // aljoud
  // Captiva 27798
  64017 : "STL030924",
  // Captiva 16096
  64018 : "STL010018",

  // Sunrich
  69239 : "STL010042",
  70835 : "STL010045",
  70770 : "STL010043",
  70781 : "STL010044",
  72073 : "STL010050",
  72072 : "STL010051",
  72101 : "STL010052",
  // limra
  63077: "STL010017"
};

const initialState = {
  activeVehicle: null,
  vssToken: "",
  isLoading: false,
};

const ImmobilizerReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ACTIVE_IMMOBILIZE_VEHICLE:
      if (state.isLoading) return state;
      if (vssDevices[action?.value?.id])
        action.value.vssID = vssDevices[action?.value?.id];
      return { ...state, activeVehicle: action.value };

    case REMOVE_ACTIVE_IMMOBILIZE_VEHICLE:
      return { ...state, activeVehicle: null };

    case SET_LOADING:
      return { ...state, isLoading: action.value };

    case UPDATE_ACTIVE_IMMOBILIZE_VEHICLE:
      return { ...state, activeVehicle: action.value };

    case SET_VSS_TOKEN:
      return { ...state, vssToken: action.value };

    default:
      return state;
  }
};

export default ImmobilizerReducer;
